// extracted by mini-css-extract-plugin
module.exports = {"footerMenu":"_de70780","heading":"_f8c8142","arrow":"_24c6da4","footerMenuLinks":"_0e2fa05","footerMenuLink":"_eedfda3","open":"_a35e8da"};